// src/components/VehicleLog/TableStyles.js
import { styled } from '@mui/material/styles';
import { Paper, TableCell, TableRow, Typography, Chip, IconButton, Box, TableSortLabel } from '@mui/material';

// Colores del tema
const colors = {
  headerBg: '#393939ff',
  headerText: '#ffffff',
  textPrimary: '#374151',
  stripBg: 'rgba(55, 65, 81, 0.08)',
  hoverBg: 'rgba(55, 65, 81, 0.12)',
  borderColor: '#e0e0e0',
  errorBg: '#393939ff',
  successBg: '#16a34a',
  successText: '#ffffff',
  errorText: '#ffffff',
  textSecondary: '#393939',
};

// Componentes de estructura
export const StyledPaper = styled(Paper)({
  width: '100%',
  overflow: 'hidden',
  border: `1px solid ${colors.borderColor}`,
  borderRadius: 8,
  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
});

export const StyledTableHeaderCell = styled(TableCell)({
  background: colors.headerBg,
  color: colors.headerText,
  fontWeight: 600,
  fontSize: '14px',
  letterSpacing: '0.025em',
  padding: '16px 24px',
  borderRight: `1px solid rgba(255,255,255,0.1)`,
  '&:last-child': {
    borderRight: 'none'
  }
});

export const StyledTableRow = styled(TableRow)({
  '&:nth-of-type(even)': {
    backgroundColor: colors.stripBg
  },
  '&:hover': {
    backgroundColor: colors.hoverBg
  },
  transition: 'background-color 0.2s ease'
});

export const StyledTableCell = styled(TableCell)({
  padding: '16px 24px',
  borderRight: `1px solid ${colors.borderColor}`,
  color: colors.textPrimary,
  '&:last-child': {
    borderRight: 'none'
  }
});

// Componentes de contenido
export const StyledText = styled(Typography)({
  fontFamily: 'sans-serif',
  fontSize: '13px',
  color: colors.textSecondary
});

export const StyledColorText = styled(Typography)({
  fontSize: '0.875rem',
  color: colors.textPrimary
});

export const StyledDateTimeText = styled(Typography)({
  fontFamily: 'monospace',
  fontSize: '0.875rem',
  color: colors.textPrimary,
  fontWeight: 400
});

export const StyledStatusChip = styled(Chip)(({ status }) => ({
  fontWeight: 600,
  fontSize: '0.75rem',
  color: status === 'active' ? "rgba(34, 197, 94, 0.8)" : "rgba(239, 68, 68, 0.8)",
  backgroundColor: "transparent",
  padding: "2px"
}));

export const StyledObservationText = styled(Typography)({
  fontSize: '0.875rem',
  color: colors.textPrimary,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: 200
});

// Componentes de acciones
export const StyledActionButton = styled(IconButton)({
  backgroundColor: '#e89b16ff',
  color: colors.successText,
  padding: '8px',
  borderRadius: '6px',
  '&:hover': {
    backgroundColor: '#f3a620ff',
    transform: 'scale(1.05)'
  },
  transition: 'all 0.2s ease'
});

export const StyledImageButton = styled(IconButton)({
  backgroundColor: '#f3f4f6',
  color: colors.textPrimary,
  padding: '8px',
  borderRadius: '6px',
  border: `1px solid ${colors.borderColor}`,
  '&:hover': {
    backgroundColor: '#e5e7eb',
    transform: 'scale(1.05)'
  },
  transition: 'all 0.2s ease'
});

export const StyledFooter = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px 24px',
  borderTop: `1px solid ${colors.borderColor}`,
  backgroundColor: '#fafafa'
});

export const StyledSortLabel = styled(TableSortLabel)({
  color: `${colors.headerText} !important`,
  fontWeight: 600,
  '& .MuiTableSortLabel-icon': {
    color: `${colors.headerText} !important`
  },
  '&:hover': {
    color: `${colors.headerText} !important`
  },
  '&.Mui-active': {
    color: `${colors.headerText} !important`
  }
});

export const StyledPendingText = styled(Typography)({
  color: '#6b6b6bff',
  fontWeight: 600,
  fontSize: '0.875rem',
  fontStyle: 'italic'
});

// Utilitarias
export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  
  return `${day}/${month}/${year} ${hours}:${minutes}`;
};